// external dependencies
import React from 'react'
import { array, object, string } from 'prop-types'
import styled from '@emotion/styled'

// css import
import 'style/layout.css'

// constants
import { sectionWrapStyling } from 'utils/styleHelpers'

// components
import Footer from 'components/Footer'
import SectionAppeal from 'components/SectionAppeal'

// styled components
const AppWrap = styled.div`
	font-family: Helvetica, Arial, sans-serif;
	width: 100%;
`

const Main = styled.main`
	${sectionWrapStyling};
`

const BarracudaLayout = ({ children, appealMdx, appealFrontmatter }) => (
	<AppWrap>
		<SectionAppeal appealMdx={appealMdx} appealFrontmatter={appealFrontmatter} />
		<Main>{children}</Main>
		<Footer logoHeight="48px" logoWidth="250px" />
	</AppWrap>
)

BarracudaLayout.propTypes = {
	children: array.isRequired,
	appealMdx: string.isRequired,
	appealFrontmatter: object.isRequired,
}

export default BarracudaLayout
